<template>
  <WidgetCard title="UTFÄRDADE MASKINBEHÖRIGHETER" subtitle="ATT GRANSKA OCH BEKRÄFTA">
    <v-data-table
      hide-default-footer
      :headers="[
        {text: 'Avser', value: 'name', width: '280', sortable: false},
        {text: 'Avtalstillhörighet', value: 'contractType', width: '129', sortable: false},
        {text: 'Behörighet', value: 'machine', width: '180', sortable: false},
        {text: 'Region', value: 'region', width: '180', sortable: false},
        {text: 'Status/Agerat', value: 'issuedBy', width: '180', sortable: false},
        {text: 'Datum', value: 'issuedOn', sortable: false, width: '100'},
        {text: '', value: 'notes', sortable: false, width: '50'}
      ]"
      :items="items"
      item-key="id"
      class="clickable"
      :items-per-page="-1"
      @click:row="clickPerson"
    >
      <!-- Application name header -->
      <template slot="item.name" slot-scope="props"
        >{{ props.item.name }} ({{ props.item.personalNumber | formatSecretPnr }})</template
      >
      <template slot="item.issuedBy" slot-scope="props">
        {{ printStatus(get(props, 'item.issuedBy', null)) }}
      </template>
      <template slot="item.issuedOn" slot-scope="props">
        <span class="widget-normal">{{ props.item.issuedOn | date }}</span>
      </template>
    </v-data-table>
  </WidgetCard>
</template>

<script>
import {mapGetters} from 'vuex'
import API from '@/services/api'
import WidgetCard from '@/components/widgets/WidgetCard.vue'
import { printStatus } from '@/helpers'
import get from 'lodash/get'

// @group Widgets
// MachinePermission component
export default {

  name: 'MachinePermission',

  components: {
    WidgetCard
  },

  data: () => ({
    items: []
  }),

  watch: {  
    handledCasesAreVisible: {
      handler(val) {
        this.getMPs()
      }
    }
  },

  computed: {
    ...mapGetters('basic', ['basicMachines', 'getMachineNameById', 'basicRegions']),
    ...mapGetters('currentuser', ['handledCasesAreVisible'])
  },

  created() {
    this.getMPs()
  },

  methods: {
    get,

    printStatus,

    clickPerson(item) {
      this.$nextTick(() =>
        this.$router.push({name: 'PersonDetail', params: {id: item.personId}, query: {tab: '2'}}).catch(() => {})
      )
    },

    /**
     * @vuese
     * Used to fetch the list of Machine certification
     * @arg called with no argument
     */
    getMPs() {

      const params = { data: { toggleMyHandledCases: this.handledCasesAreVisible } }

      API.widgetMachineCertification(params)
        .then(res => {

          this.items = []

          this.items = res.data.rows.map(mp => {
            let employmentType = []
            
            if( mp.person?.apprenticeships.length ) {
              employmentType = mp.person?.apprenticeships
            }

            if( mp.person?.employments.length ) {
              employmentType = mp.person?.employments
            }

            return {
              personalNumber: mp.person && mp.person.personalNumber ? mp.person.personalNumber : '',
              contractType: employmentType[0]?.company?.contracttype?.name ?? '',
              personId: mp.person && mp.person.id ? mp.person.id : '',
              machine: mp.machineId ? this.getMachineNameById(mp.machineId) : '',
              name:
                mp.person && mp.person.firstName && mp.person.lastName
                  ? `${mp.person.firstName} ${mp.person.lastName}`
                  : '',
              state: mp.approvedById ? mp.approvedById : 0,
              region: mp.region ? mp.region.name : '',
              issuedOn: mp.issuedOn ? mp.issuedOn : null,
              issuedBy: mp?.issuedBy ? `${ mp.issuedBy?.firstName } ${ mp.issuedBy?.lastName }` : null
            }
          })
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
</style>